import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, qs } from './api.ts';
import { unreadKey } from './live.ts';
import type { AppNotification } from './types.ts';

type ListResponse = { items: AppNotification[]; unreadCount: number };

/** Unread badge count. Kept current by the live connection; fetched once on load. */
export function useUnreadCount(enabled: boolean) {
  return useQuery({
    queryKey: unreadKey,
    queryFn: async () => (await api.get<ListResponse>('/api/notifications?limit=1')).unreadCount,
    enabled,
    staleTime: Infinity,
  });
}

export function useNotificationList(limit: number, enabled = true) {
  return useQuery({
    queryKey: ['notifications', 'list', limit],
    queryFn: () => api.get<ListResponse>(`/api/notifications${qs({ limit })}`),
    enabled,
  });
}

export function useMarkRead() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (ids?: number[]) =>
      api.post<{ unreadCount: number }>('/api/notifications/read', ids ? { ids } : {}),
    onSuccess: ({ unreadCount }) => {
      client.setQueryData(unreadKey, unreadCount);
      void client.invalidateQueries({ queryKey: ['notifications', 'list'] });
    },
  });
}
